///<reference lib="dom" />
///<reference lib="webworker" />
///<reference lib="esnext" />
import createMessageListener from "@utils/createMessageListener";
import createPostMessage from "@utils/createPostMessage";
import logger from "@utils/logger";
import { bindWritable } from "@utils/storeUtils/bindWritable";
import type {
  EventRecord,
  GetEventTarget,
  GetMessagePort,
  ILivechatSession,
  LivechatReadyState,
} from "@utils/types";
import LivechatWebsocket from "./LivechatWebsocket";
import type {
  ReceiveMessageEventRecord,
  SendMessageEventRecord,
} from "./types";

export declare const self: SharedWorkerGlobalScope | DedicatedWorkerGlobalScope;

const livechatWebsocket = new LivechatWebsocket();

function instanceOfSharedWorker(self: any): self is SharedWorkerGlobalScope {
  try {
    return "onconnect" in self;
  } catch {}
  return false;
}

if (instanceOfSharedWorker(self)) {
  self.addEventListener("connect", event => {
    const [port] = event.ports;
    port.start();
    port.onmessageerror = e => console.error(e);

    connectPort(
      () => port,
      () => port
    );
  });
} else {
  connectPort(
    () => self,
    () => self
  );
}

function connectPort(messagePort: GetMessagePort, eventTarget: GetEventTarget) {
  const postMessage = createPostMessage<ReceiveMessageEventRecord>(messagePort);
  const messageListener =
    createMessageListener<SendMessageEventRecord>(eventTarget);

  const bind = bindWritable<
    EventRecord<"bind:session", ILivechatSession> &
      EventRecord<"bind:readyState", LivechatReadyState> &
      EventRecord<"bind:debug", boolean>
  >(postMessage, messageListener);

  bind("bind:session", livechatWebsocket.session).sync();
  bind("bind:readyState", livechatWebsocket.readyState);
  bind("bind:debug", logger.enabled).sync();

  livechatWebsocket.addEventListener("message", ({ detail }) => {
    postMessage(detail.name, detail.value);
  });

  livechatWebsocket.addEventListener("error", ({ detail }) =>
    postMessage(detail.name, detail.value)
  );

  messageListener("send:message", event =>
    livechatWebsocket.send(event.data.value)
  );
}

export {};
